export default __webpack_public_path__ + "static/media/Shang_Bo_Zhang.07665447.png";